import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import Navbar from "@/components/Navbar";
import { ListMusic, CheckCircle, ChevronRight } from "lucide-react";

export default function PlaylistList() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/playlists")
      .then((r) => setItems(r.data || []))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Navbar />
      <main className="max-w-6xl mx-auto px-6 py-12">
        <div className="mb-10">
          <div className="text-xs uppercase tracking-[0.3em] font-bold text-brand-gold mb-4">Guided programs</div>
          <h1 className="text-4xl lg:text-5xl font-black tracking-tight flex items-center gap-4" data-testid="playlist-list-title">
            <ListMusic className="w-10 h-10 text-brand-gold" /> Playlists
          </h1>
          <p className="mt-3 font-mono text-muted-foreground max-w-2xl">
            Admin ne aapke liye curated practice programs banaye hain — ek playlist chunkar sequence me practice karo.
          </p>
        </div>

        {loading ? (
          <div className="font-mono text-muted-foreground">Loading…</div>
        ) : items.length === 0 ? (
          <div className="border-2 border-dashed border-border p-12 text-center" data-testid="playlist-empty">
            <ListMusic className="w-12 h-12 mx-auto text-neutral-300 mb-4" />
            <h3 className="text-xl font-black tracking-tight">No playlists yet</h3>
            <p className="mt-2 font-mono text-sm text-muted-foreground">Admin will publish curated programs here. Meanwhile, practice from the modules on your dashboard.</p>
          </div>
        ) : (
          <div className="grid md:grid-cols-2 gap-4" data-testid="playlist-grid">
            {items.map((p) => {
              const pct = p.item_count > 0 ? Math.round((p.completed_count / p.item_count) * 100) : 0;
              return (
                <Link
                  key={p.id}
                  to={`/playlists/${p.id}`}
                  data-testid={`playlist-card-${p.id}`}
                  className="group border border-border p-6 flex flex-col hover:border-brand-gold/40 hover:-translate-y-1 transition-all bg-card"
                >
                  <div className="text-[10px] uppercase tracking-[0.3em] font-bold text-muted-foreground/70 mb-2">
                    {p.item_count} exercise{p.item_count === 1 ? "" : "s"}
                  </div>
                  <h3 className="text-2xl font-black tracking-tight">{p.name}</h3>
                  {p.description && (
                    <p className="mt-2 font-mono text-sm text-muted-foreground line-clamp-3">{p.description}</p>
                  )}
                  <div className="mt-6 mb-1 flex items-center justify-between text-[10px] uppercase tracking-widest font-bold">
                    <span>{pct}% complete</span>
                    <span className="text-brand-gold">{p.completed_count}/{p.item_count}</span>
                  </div>
                  <div className="h-1.5 bg-secondary/60">
                    <div className="h-full bg-brand-blue transition-all" style={{ width: `${pct}%` }} />
                  </div>
                  <div className="mt-4 flex items-center gap-2 text-xs uppercase tracking-widest font-bold text-brand-gold">
                    Open <ChevronRight className="w-3.5 h-3.5" />
                  </div>
                </Link>
              );
            })}
          </div>
        )}
      </main>
    </div>
  );
}
